(function () {
    'use strict';

    angular.module("imApp").factory("pickJobGrpService", ['$ihttp', function ($ihttp) {
        let service = {
            getPickJobGroup: function (parms) {
                return $ihttp.post({
                    method: 2166,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2167,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
